module.exports = __webpack_public_path__ + "assets/asset_train.93cd49f1.svg";